import { Tag, Space } from "antd";
import { Dayjs } from "dayjs";
import { FormFilters } from "../../types/formFilters";
import { criteriaLabelMap } from "../Forms/utils";
import { STATUS_OPTIONS, VALIDATION_OPTIONS } from "../../utils/constants";
import styles from "./AppliedTaskFilters.module.css";

interface AppliedTaskFiltersProps {
  filters: FormFilters;
  onRemoveFilter: (filterType: keyof FormFilters, value?: string) => void;
  onClearAll: () => void;
}

const AppliedTaskFilters = ({ filters, onRemoveFilter, onClearAll }: AppliedTaskFiltersProps) => {
  const hasAnyFilters = 
    filters.criteria.length > 0 ||
    filters.creationDate !== null ||
    filters.status.length > 0 ||
    filters.taskValidation.length > 0;

  if (!hasAnyFilters) {
    return null;
  }

  const getStatusLabel = (status: string) => {
    const statusOption = STATUS_OPTIONS.find(option => option.value === status);
    return statusOption?.label || status;
  };

  const getValidationLabel = (validation: string) => {
    const validationOption = VALIDATION_OPTIONS.find(option => 
      option.value === validation || 
      (validation === 'validated' && option.value === 'VALIDATED') ||
      (validation === 'pending' && option.value === 'REVISION')
    );
    return validationOption?.label || validation;
  };

  const formatDateRange = (dates: [Dayjs | null, Dayjs | null] | null) => {
    if (!dates || !dates[0] || !dates[1]) return null;
    return `${dates[0].format('DD/MM/YYYY')} - ${dates[1].format('DD/MM/YYYY')}`;
  };

  return (
    <div className={styles.container}>
      
      <Space wrap className={styles.tagsContainer}>
        {filters.criteria.length > 0 && <span className={styles.title}>Criteris:</span>}
        {filters.criteria.map((criteria) => (
          <Tag
            key={`criteria-${criteria}`}
            closable
            onClose={() => onRemoveFilter('criteria', criteria)}
            className={styles.filterTag}
          >
            {criteriaLabelMap[criteria] || criteria}
          </Tag>
        ))}

        {filters.creationDate && <span className={styles.title}>Data de la tasca:</span>}
        {filters.creationDate && (
          <Tag
            closable
            onClose={() => onRemoveFilter('creationDate')}
            className={styles.filterTag}
          >
            {formatDateRange(filters.creationDate)}
          </Tag>
        )}

        {filters.status.length > 0 && <span className={styles.title}>Estat de la tasca:</span>}
        {filters.status.map((status) => (
          <Tag
            key={`status-${status}`}
            closable
            onClose={() => onRemoveFilter('status', status)}
            className={styles.filterTag}
          >
            {getStatusLabel(status)}
          </Tag>
        ))}

        {filters.taskValidation.length > 0 && <span className={styles.title}>Validació:</span>}
        {filters.taskValidation.map((validation) => (
          <Tag
            key={`validation-${validation}`}
            closable
            onClose={() => onRemoveFilter('taskValidation', validation)}
            className={styles.filterTag}
          >
            {getValidationLabel(validation)}
          </Tag>
        ))}
          <button 
            className={styles.clearAllButton}
            onClick={onClearAll}
          >
            Borrar filtres
          </button>
      </Space>
    </div>
  );
};

export default AppliedTaskFilters;
